<script>
import CompanyInput from "./CompanyInput.vue"
import CompanyService from "@/services/CompanyService"

export default {
  name: "CompaniesOwnedInput",
  extends: CompanyInput,
  methods: {
    getData() {
      return CompanyService.getOwned()
    }
  }
}
</script>
